<td class="text-end font-italic text-secundary">{{route.HumanStartDagTijd}}</td>
<td class="text-end font-italic text-secundary">{{getCutoffTime(route) | date:'HH:mm'}} uur</td>
<td>
  <b>{{route.Name}}</b> <span class="badge text-bg-success ms-2">{{route.Code}}</span><br />
  {{route.Description}}
</td>
<td class="font-italic text-secundary">{{route.HumanEindDagTijd}}</td>
<td class="text-secundary">{{route.Duration}} minuten</td>
